import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { StaticPillList } from './../../../reusable/Form/PillList';
import { hashHistory } from 'react-router';
import { ENTITY_CATEGORIES_VISIBLE_COUNT } from './../../../constants';
import { withPermission } from './../../../context';


class EntityCategoriesPillList extends PureComponent {
    static propTypes = {
        entity: PropTypes.object.isRequired,
        categories: PropTypes.array.isRequired,
        onRemoveEntity: PropTypes.func,
        visibleItemCount: PropTypes.number,
        permission: PropTypes.object
    }

    static defaultProps = {
        visibleItemCount: ENTITY_CATEGORIES_VISIBLE_COUNT,
        permission: { canEdit: true }
    }



    constructor(props) {
        super(props);

        this.handleRemoveCategory = this.handleRemoveCategory.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
    }

    handleRemoveCategory(category) {
        this.props.onRemoveEntity(this.props.entity, category);
    }

    handleShowMore() {
        hashHistory.push(`/edit-third-party/${this.props.entity.id}`);
    };

    render() {
        // filter out ghost categories (deleted but still showing in entities call)
        const categories = this.props.categories.filter(cat => !!cat.id);

        return <StaticPillList items={categories}
                               onRemoveItem={this.props.permission.canEdit && this.props.onRemoveEntity && this.handleRemoveCategory}
                               visibleItemCount={this.props.visibleItemCount}
                               onShowMore={this.handleShowMore}/>;
    }
}

export default withPermission(EntityCategoriesPillList)


// WEBPACK FOOTER //
// ./src/scripts/pages/Entities/components/EntityCategoriesPillList.jsx